import script from "./action.vue?vue&type=script&lang=ts&setup=true"
export * from "./action.vue?vue&type=script&lang=ts&setup=true"

import "./action.vue?vue&type=style&index=0&id=1723f056&lang=scss"

const __exports__ = script;

export default __exports__